/** Required by react-draggable / react-rnd in the browser bundle. */
if (typeof globalThis.process === "undefined") {
  globalThis.process = { env: {} };
}
